import React from 'react';
import { Events, track } from 'utils/analytics';
import CtaArrowIcon from './CtaArrowIcon';
import { HeroCtaButton, HeroCtaButtonContent } from './styles';

type Props = {
  onClick: () => void;
  label?: string;
};

const HeroQuotesCta: React.FC<Props> = ({ onClick, label = 'Compare quotes' }) => {
  const handleClick = () => {
    track(Events.CLICKED_BUTTON, { analyticsText: label });
    onClick();
  };

  return (
    <HeroCtaButton type="button" onClick={handleClick}>
      <HeroCtaButtonContent>
        {label}
        <CtaArrowIcon />
      </HeroCtaButtonContent>
    </HeroCtaButton>
  );
};

export default HeroQuotesCta;
